export default __webpack_public_path__ + "locales/bg/DeleteProfileEverDialog.json?hash=5e930f591c326c154083c6a1f6c7a00d";